import type { SendMessageRequest, SendMessageResponse } from "@/backend/natsstubs/sightline/models";

import { retrieveBackendSession } from "../impl/backendSessionCache";

export async function sendSightlineMessage(
  request: SendMessageRequest,
): Promise<SendMessageResponse> {
  const session = retrieveBackendSession();
  if (!session) {
    throw new Error("Backend session not initialized");
  }
  return await session.sendSightlineMessage(request);
}

export async function stopSightlineMessage(messageId: string): Promise<void> {
  const session = retrieveBackendSession();
  if (!session) {
    throw new Error("Backend session not initialized");
  }
  await session.stopSightlineMessage(messageId);
}
